import { Component } from "@angular/core";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-footer-banner",
  standalone: true,
  imports: [ToastModule],
  providers: [MessageService],
  templateUrl: "./footer-banner.component.html",
  styleUrl: "./footer-banner.component.css",
})
export class FooterBannerComponent {

  private insizonFrontendBaseUrl = environment.insizonFrontendBaseUrl;
  currentYear: number = new Date().getFullYear();
  insizonUrl = environment.insizonFrontendBaseUrl;
  constructor(private messageService: MessageService){}
  

  get getBugRepoLink() {
    return `${this.insizonFrontendBaseUrl}/bug-logs;`
  }

  get getFeatureLink() {
    return `${this.insizonFrontendBaseUrl}/`;
  }

  get getContactUsLink() {
    return `${this.insizonFrontendBaseUrl}/contact`;
  }

  noLink() {
    this.messageService.add({
      severity: "warn",
      summary: "No Link Found",
      detail: "Social media link is not available.",
    });
  }
}
